import { render } from "./SteelColumn.vue?vue&type=template&id=04e1db4c"
import script from "./SteelColumn.vue?vue&type=script&lang=js"
export * from "./SteelColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__